// Home Scroll Effects
Object.assign(window.HiSnaps, {

    home: {
        
        initScrollEffects() {
            const fixedHeroImages = $1(".hero.fixed");
            const mainHero = $1(".hero.fixed img.snap");
            const snappedHeroFixed = $1(".hero.fixed img.snapped");
            const mobileSnap = $1(".intro .mob-hero");

            const mastAnchor = $1(".mast .ioAnchor");
            const introAnchor = $1(".intro .ioAnchor");
            const mobileSnapAnchor = $1(".interlude .ioAnchor");

            // The fixed hero markup is only present when the simple hero is off
            // (see use_simple_hero in templates/index.liquid). Skip its observers
            // entirely when it's absent so we don't touch null elements.
            if (fixedHeroImages && mainHero && snappedHeroFixed) {
                // Observer for mast section - triggers image transition.
                const mastObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            mainHero.classList.remove("blurred");
                            snappedHeroFixed.classList.add("blurred");
                        } else {
                            mainHero.classList.add("blurred");
                            snappedHeroFixed.classList.remove("blurred");
                        }
                    });
                });

                // Observer for pinning when we want our hero to scroll with the next section.
                const unpinObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const rect = entry.boundingClientRect;
                        const isAboveViewport = rect.bottom < 0;

                        if (entry.isIntersecting) {
                            fixedHeroImages.classList.add("pinned");
                        } else if (!isAboveViewport) {
                            fixedHeroImages.classList.remove("pinned");
                        }
                    });
                });

                mastObserver.observe( mastAnchor );
                unpinObserver.observe( introAnchor );

                // Handle initial fixed-hero state on load (if page loads scrolled down).
                requestAnimationFrame(() => {
                    const introRect = introAnchor.getBoundingClientRect();
                    if (introRect.bottom < 0) {
                        fixedHeroImages.classList.add("pinned");
                    }

                    const mastRect = mastAnchor.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const isIntersecting = mastRect.top < viewportHeight && mastRect.bottom > 0;

                    if (!isIntersecting) {
                        mainHero.classList.add("blurred");
                        snappedHeroFixed.classList.remove("blurred");
                    } else {
                        mainHero.classList.remove("blurred");
                    }
                });
            }

            // Observer for interlude animation (drives the mobile / simple-hero snapped image).
            if (mobileSnap && mobileSnapAnchor) {
                const mobileSnapObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const rect = entry.boundingClientRect;
                        const isAboveViewport = rect.bottom < 0;

                        if (entry.isIntersecting) {
                            mobileSnap.classList.add("show");
                        } else if (!isAboveViewport) {
                            mobileSnap.classList.remove("show");
                        }
                    });
                });
                mobileSnapObserver.observe( mobileSnapAnchor );

                // Handle initial snapped-image state on load (if page loads scrolled down).
                requestAnimationFrame(() => {
                    const mobileSnapRect = mobileSnapAnchor.getBoundingClientRect();
                    if (mobileSnapRect.bottom < 0) {
                        mobileSnap.classList.add("show");
                    }
                });
            }

            // Simple hero (desktop): the reused .hero.fixed snapped image fades in
            // and drifts down as it scrolls into view — no blur. Only present when
            // use_simple_hero is on (see templates/index.liquid). The trigger point
            // can be tuned via the observer's rootMargin below.
            const simpleHero = $1("body.simple-hero .hero.fixed");
            if (simpleHero) {
                const revealSimpleHero = () => {
                    const rect = simpleHero.getBoundingClientRect();
                    if (rect.top < window.innerHeight && rect.bottom > 0) {
                        simpleHero.classList.add("show");
                    } else if (rect.bottom >= 0) {
                        simpleHero.classList.remove("show");
                    }
                };

                const simpleHeroObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const isAboveViewport = entry.boundingClientRect.bottom < 0;
                        if (entry.isIntersecting) {
                            simpleHero.classList.add("show");
                        } else if (!isAboveViewport) {
                            simpleHero.classList.remove("show");
                        }
                    });
                }, { rootMargin: "0px 0px -50% 0px" });
                simpleHeroObserver.observe( simpleHero );

                // Reveal immediately if it's already in view on load.
                requestAnimationFrame( revealSimpleHero );
            }
        },

        initButtons() {
            const vibesBtn = $1(".vibes-btn");
            if (vibesBtn) {
                vibesBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    $1("section.vibes").scrollIntoView({ behavior: 'smooth' });
                });
            }

            const readReviewsBtn = $1(".read-reviews");
            if (readReviewsBtn) {
                readReviewsBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    window.location.href = '/products/drink-boosters?t=reviews';
                });
            }
        }

    }

});